module.exports = __webpack_public_path__ + "img/border-right.53d5754f.svg";